var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v("Todos os direitos reservados © "+_vm._s(_vm.ano))])])])])]),_c('modal-encryption-pdf')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }